// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__1V8NJ","containerItemsCenter":"Skeleton_containerItemsCenter__1v5O9"};